import {
    AfterViewInit,
    ChangeDetectionStrategy, Component, ComponentRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewContainerRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { ModulesLazyService } from '@core/infrastructure/modules/modules-lazy.service';
import { LoadLazyCmsModule } from '@core/infrastructure/state/core-commands.actions';

@Component({
    selector: 'cms-render-lazy',
    template: '<ng-template #templateCmsLazy></ng-template>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class CmsRenderLazyComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() public readonly slug: string;

    @ViewChild('templateCmsLazy', { read: ViewContainerRef })
    private readonly templateCmsLazy: ViewContainerRef;

    public lazyFooterComponent: ComponentRef<any>;

    public loadModule$: Observable<boolean> = this.modulesLazyService.moduleLoad$.pipe(
        filter((modules) => modules?.CmsRenderUiModule),
        map((modules) => modules.CmsRenderUiModule),
        take(1),
    );

    constructor(
        private readonly store: Store,
        private readonly modulesLazyService: ModulesLazyService,
    ) {}

    public ngOnInit() {
        this.store.dispatch(LoadLazyCmsModule());
    }

    public ngAfterViewInit(): void {
        this.loadModule$.subscribe(module => {
            this.inyectComponent(module);
        });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!changes.slug?.isFirstChange() && changes.slug?.currentValue !== changes.slug?.previousValue) {
            this.reloadSlug(changes.slug.currentValue);
        }
    }

    public reloadSlug(slug: string) {
        if (!slug) {
            return;
        }
        this.lazyFooterComponent.instance.slug = slug;
        this.lazyFooterComponent.changeDetectorRef.detectChanges();
    }

    private inyectComponent(moduleRef) {
        this.templateCmsLazy.clear();

        const intanceRender = moduleRef.instance.cmsContentRenderComponent;
        const componentFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(intanceRender);

        this.lazyFooterComponent = this.templateCmsLazy.createComponent(componentFactory);
        this.reloadSlug(this.slug);
    }
}
